<!-- Component that implements the search and visualization of documents -->
<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="elevation-10">
          <v-toolbar :color="'primary white--text'" :dense="projeto.titulo.length > 130"
            :prominent="projeto.titulo.length > 130">
            <v-spacer></v-spacer>
            <v-card flat color="primary" v-if="projeto.titulo.length > 130">
              <v-card-title color="primary white--text">
                <div class="titulo">
                  Editar {{ projeto.classificacaoSecundaria.descricao }} nº {{ idProjeto }} - {{ projeto.titulo }}
                  <a v-if="extensao.registroSIEX"
                    :href="'http://siex1.ufes.br/siex/AuditarAcaoExtensao.do?id=' + this.acaoExtensao.id"
                    style="color: white; text-decoration: underline;" target="_blank">SIEX #{{ extensao.registroSIEX
                    }}</a>
                  {{ administrador && extensao.idProjetoDuplicacao ? '(duplicada)' : '' }}
                </div>
              </v-card-title>
            </v-card>
            <v-toolbar-title v-if="projeto.titulo.length <= 130">
              Editar {{ projeto.classificacaoSecundaria.descricao }} nº {{ idProjeto }} - {{ projeto.titulo }}
              <a v-if="extensao.registroSIEX"
                :href="'http://siex1.ufes.br/siex/AuditarAcaoExtensao.do?id=' + this.acaoExtensao.id"
                style="color: white; text-decoration: underline;" target="_blank">SIEX #{{ extensao.registroSIEX }}</a>
              {{ administrador && extensao.idProjetoDuplicacao ? '(duplicada)' : '' }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tabs centered show-arrows dark next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline" color="primary" hide-slider slot="extension">
              <router-link class="router_disable" exact :to="{ name: 'EditarInformacoes' }"
                tag="v-tab">Informações</router-link>
              <router-link class="router_disable" exact :to="{ name: 'EditarClassificacao' }"
                tag="v-tab">Classificações</router-link>
              <router-link class="router_disable" exact :to="{ name: 'EditarExtensao' }"
                tag="v-tab">Extensão</router-link>
              <router-link class="router_disable" exact :to="{ name: 'IntegrantesProjeto' }"
                tag="v-tab">Equipe</router-link>
              <router-link class="router_disable" exact :to="{ name: 'AtividadesProjeto' }"
                tag="v-tab">Atividades</router-link>
              <router-link class="router_disable" exact :to="{ name: 'VinculosProjeto' }"
                tag="v-tab">Vínculos</router-link>
              <router-link class="router_disable" exact :to="{ name: 'ParceriasProjeto' }"
                tag="v-tab">Parcerias</router-link>
              <router-link class="router_disable" exact :to="{ name: 'AbrangenciaProjeto' }"
                tag="v-tab">Abrangência</router-link>
              <!-- <router-link class="router_disable" :to="{name: 'BolsasProjeto'}" tag="v-tab">Bolsas</router-link> -->
              <router-link class="router_disable" exact :to="{ name: 'ArquivosProjeto' }"
                tag="v-tab">Arquivos</router-link>
              <router-link class="router_disable" exact :to="{ name: 'EditarContatos' }"
                tag="v-tab">Contatos</router-link>
              <router-link class="router_disable" exact
                v-if="habilitaRelatorio() || (username === 'athelson.bittencourt' && idProjeto == 102)"
                :to="{ name: 'RelatoriosProjeto' }" tag="v-tab">Relatórios</router-link>
            </v-tabs>

          </v-toolbar>
          <v-card-text>
            <router-view :idProjeto="idProjeto" :projeto="this.projeto"></router-view>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['idProjeto'],
  data: () => ({
    projeto: {
      situacao: {},
      tipoPublico: {},
      classificacoesPrimariaSecundaria: [{}, {}]
    },
    extensao: {},
    acaoExtensao: {},
    contatos: {}
  }),
  computed: {
    ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    carregaAcaoExtensao: function (registro) {
      projetos.getAcaoExtensao(registro)
        .then(response => {
          let listaAcaoExtensao = response.data.slice()
          this.acaoExtensao = listaAcaoExtensao[0]
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
        })
    },
    // Verifica se a ação de extensão é um curso/oficina (antigo).
    acaoCursoOficina: function () {
      if (this.projeto.classificacaoSecundaria.id === 39729) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão é um curso.
    acaoCurso: function () {
      if (this.projeto.classificacaoSecundaria.id === 44194) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão é um oficina.
    acaoOficina: function () {
      if (this.projeto.classificacaoSecundaria.id === 44195) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão é um evento.
    acaoEvento: function () {
      if (this.projeto.classificacaoSecundaria.id === 39730) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o tipo de ação de extensão está habilitado a ter a aba Relatórios.
    tipoAcaoExtensaoHabilitado: function () {
      if (this.acaoCursoOficina() || this.acaoCurso() || this.acaoOficina() || this.acaoEvento()) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function () {
      if (this.projeto.situacao.item === 18) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function () {
      if (this.projeto.situacao.item === 20) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Relatório aguardando aprovação".
    situacaoRelatorioAguardandoAprovacao: function () {
      if (this.projeto.situacao.item === 22) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Concluído".
    situacaoConcluido: function () {
      if (this.projeto.situacao.item === 19) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Cancelado".
    situacaoCancelado: function () {
      if (this.projeto.situacao.item === 5) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a situação da ação de extensão está habilitada a ter a aba Relatórios.
    situacaoAcaoExtensaoHabilitado: function () {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio() || this.situacaoRelatorioAguardandoAprovacao() || this.situacaoConcluido() || this.situacaoCancelado()) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function () {
      if (this.administrador === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function () {
      if ((this.projeto.funcao != null && this.projeto.funcao.item === 1)) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function () {
      if (this.projeto.assessor === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é usuário Proex.
    usuarioProex: function () {
      if (this.usuarioPROEX === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado está habilitado para a aba Relatórios.
    usuarioHabilitado: function () {
      if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor() || this.usuarioProex()) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
    relatorioHabilitadoAcaoRegistroTardio: function () {
      if (this.projeto.relatorioFinalHabilitado === true) {
        return true
      } else {
        return false
      }
    },
    habilitaRelatorio: function () {
      if ((this.tipoAcaoExtensaoHabilitado() && this.situacaoAcaoExtensaoHabilitado()) || this.relatorioHabilitadoAcaoRegistroTardio()) {
        return true
      } else {
        return false
      }
    }
  },
  mounted: function () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
    projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.projeto.dataInicio = dates.format(this.projeto.dataInicio)
        this.projeto.dataConclusao = dates.format(this.projeto.dataConclusao)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
    projetos.getExtensaoDoProjeto(this.idProjeto)
      .then(response => {
        this.extensao = response.data
        this.carregaAcaoExtensao(this.extensao.registroSIEX)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
      })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' })
    projetos.getContatosDoProjeto(this.idProjeto)
      .then(response => {
        this.contatos = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' })
      })
  },
  components: {
    'basic-toolbar': BasicToolbar
  }
}
</script>

<style lang="css" scoped>
.v-tab {
  margin-left: 0.5em;
  border-top-right-radius: 1em !important;
  border-top-left-radius: 1em !important;
  transform: perspective(25px) rotateX(2deg) !important;
  transform-origin: bottom !important;
  max-width: 12em !important;
  min-width: 4em !important;
}

.v-tab:not(.router-link-active) {
  color: #dddddd !important;
  background-color: #848484 !important;
}

.v-tab.router-link-active {
  color: black !important;
  background-color: white !important;
}

.v-tab>>>.tabs__container {
  transition: -webkit-transform .3s cubic-bezier(.86, 0, .07, 1);
  transition: transform .3s cubic-bezier(.86, 0, .07, 1);
}

.router_disable {
  pointer-events: none;
}

.titulo {
  color: white;
  text-align: justify;
  font-size: 14pt;
}
</style>



// WEBPACK FOOTER //
// editar-projeto.vue?c06da714